module.exports = __webpack_public_path__ + "img/option_icon.0e175c76.svg";